import { Button, FormControl } from '@mui/material';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  padding-bottom: 24px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

export const StyledHeader = styled.div`
  display: flex;
  align-items: center;
`;

export const BackToList = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  flex: 1 0 0;
`;

export const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--luft-primary);
  text-transform: none;
  font-size: 13px;
  font-weight: 500;
  height: 30px;
`;

export const SerialText = styled.div`
  color: var(--luft-primary);
  font-size: 16px;
  font-weight: 700;
`;

export const DetailsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
`;

export const ContainerTemperatureChart = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
`;

export const ChartHeader = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  gap: 24px;
  justify-content: space-between;
`;

export const ChartHeaderText = styled.div`
  color: var(--luft-primary);
  font-family: 'Work Sans';
  font-size: 16px;
  font-weight: 700;
  flex: 1 0 0;
`;

export const SelectContainer = styled(FormControl)`
  width: 220px;
`;
